// Avoid crash if user has turned off local storage
const getStorage = (storage) => {
  try {
    return window[storage];
  } catch (e) {
    return {
      getItem: () => null,
      setItem: () => null,
    };
  }
};

export const getLocalStorage = () => getStorage('localStorage');
export const getSessionStorage = () => getStorage('sessionStorage');
